import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import SecondaryButton from "../components/Buttons/SecondaryButton";

interface UsageLimitModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dailyLimit?: number;
}

const UsageLimitModal: React.FC<UsageLimitModalProps> = ({
  isOpen,
  setIsOpen,
  dailyLimit = 10,
}) => {
  const resetTime = useMemo(() => {
    const now = new Date();
    const nextMidnightUTC = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)
    );
    return nextMidnightUTC.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }, []);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="text-left">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Daily limit reached
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          You've reached your daily limit of {dailyLimit} pages. Your limit will reset at{" "}
          <span className="font-medium">{resetTime}</span>.
        </p>
        <p className="text-sm text-gray-600 mb-6">
          Want unlimited pages? Upgrade to Pro for unrestricted access.
        </p>
        <div className="flex gap-3 justify-end">
          <SecondaryButton type="button" onClick={() => setIsOpen(false)}>
            Close
          </SecondaryButton>
          <Link to="/pricing">
            <PrimaryButton type="button" onClick={() => setIsOpen(false)}>
              View plans
            </PrimaryButton>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

export default UsageLimitModal;
